import { inject, Injectable } from '@angular/core';
import { ActivationEnd, Router, Event } from '@angular/router';
import { Util } from '../core-utilities/Util';

@Injectable({ providedIn: 'root' })
export class RouteData {
    routeData: any;

    constructor(private util: Util) {
        const router = inject(Router);
        router.events.subscribe((event: Event) => {
            if (
                event instanceof ActivationEnd &&
                this.util.isActivationEndForFullPath(event)
            ) {
                this.routeData = this.util.getFullDataFromSnapshot(
                    event.snapshot
                );
            }
        });
    }

    hideFooter() {
        return !this.routeData || this.routeData.hideFooter;
    }

    hideNavbar() {
        return !this.routeData || this.routeData.hideNavbar;
    }
}
